export default "__VITE_ASSET__CadYnp9O__"